<template>
	<div id="app-wrapper" class="bg-back-white">
		<RouterView />
	</div>
</template>

<script>
import { RouterView } from 'vue-router';

import { analytics } from '@/firebase';
import { logEvent } from 'firebase/analytics';

export default {
	name: 'App',
	components: {
		RouterView,
	},
	mounted() {
		logEvent(analytics, 'app_opened');
	},
}
</script>
